import { Injectable } from '@angular/core';
import { HttpClientService } from '../../implementacion/http-client.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { dcmusuario } from '../../../models/SicarMap/dcmusuario.model';



@Injectable({
  providedIn: 'root'
})
export class rangosMPService {
  headers: any;
  constructor( private http: HttpClientService) {
        }
  setRangoMP(listaRangosMP: dcmusuario[]) {
    return this.http.post(`${environment.apiScar}RangoModelo/SetRangosPersonalizados`, listaRangosMP)
      .pipe(map(response => response));
  }
}
